import BaseApiUploadRequest from "./BaseApiUploadRequest";
import { METHOD } from "../Constants";
import { FILE_UPLOAD_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class FileUploadRequest extends BaseApiUploadRequest {
  method = METHOD.HTTP.POST;

  url = FILE_UPLOAD_URL;

  body = null;

  constructor(accountId, file, fileType, description) {
    super();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("accountId", accountId);
    if (fileType) {
      formData.append("fileType", fileType);
    }
    if (description) {
      formData.append("description", description);
    }
    this.body = formData;
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
